import { apiClient } from "@/api/api-client";

export interface AllUserSession {
	id: number;
	user_id: string;
	user_name: string;
	user_email: string;
	user_role?: string;
	name: string;
	ip_address?: string;
	user_agent?: string;
	created_at: string;
	last_used_at?: string;
	logged_out_at?: string;
	is_logged_out: boolean;
}

export interface AllUserSessionsResponse {
	data: AllUserSession[];
	meta?: {
		total_active: number;
		total_users: number;
		total_sessions: number;
	};
}

const allUserSessionsService = {
	/**
	 * Get all user sessions (admin only)
	 */
	getAllSessions: async (params?: {
		status?: "active" | "logged_out" | "all";
		user_id?: string;
	}): Promise<AllUserSessionsResponse> => {
		const response = await apiClient.get<AllUserSessionsResponse>("/admin/all-user-sessions", { params });
		return response.data;
	},

	/**
	 * Terminate a specific user session
	 */
	terminateSession: async (sessionId: number): Promise<{ message: string }> => {
		const response = await apiClient.delete(`/admin/all-user-sessions/${sessionId}`);
		return response.data;
	},

	/**
	 * Terminate all sessions for a specific user
	 */
	terminateUserSessions: async (userId: string): Promise<{ message: string }> => {
		const response = await apiClient.post(`/admin/all-user-sessions/terminate-user/${userId}`);
		return response.data;
	},

	/**
	 * Terminate all active sessions (except current admin)
	 */
	terminateAllSessions: async (): Promise<{ message: string }> => {
		const response = await apiClient.post("/admin/all-user-sessions/terminate-all");
		return response.data;
	},
};

export default allUserSessionsService;
